import fetch from './../fetch';

const query = (id) => {
    return fetch.get(`course/assess/result/entering/${id}`)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const deleteFile = (dataList) => {
    const ids = dataList.map(d => d.id);
    return fetch.post('course/assess/result/file/delete', ids);
}

const save = (data) => {
    return fetch.post('course/assess/result/save', data);
}

const update = (data) => {
    return fetch.post('course/assess/result/update', data);
}

const getOrgEmployee = (orgId) => {
    return fetch.get('org/get/employee/' + orgId)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const getMajorByOrgId = (orgId) => {
    return fetch.get('org/get/major/' + orgId)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    query,
    upload: `${fetch.base}course/assess/result/file`,
    deleteFile,
    save,
    update,
    getOrgEmployee,
    getMajorByOrgId
}